<script lang="ts">
	import { CantPayOnlineReason } from "@core/schema/CantPayOnlineReason.js";
	import { maxOnlinePrice } from "@core/schema/maxOnlinePrice.js";
	import { getCartPath } from "@core/schema/paths/getCartPath.js";
	import { getPriceOfOrder } from "@core/schema/utils/getPriceOfOrder.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { getCartStore } from "../contexts/cartContextKey.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { cartSummaryHeight } from "../state/cartSummaryHeight.svelte.js";
	import Button from "./common/Button.svelte";
	import Link from "./common/Link.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	interface Props {
		hide?: boolean;
		isButtonDisabled?: boolean;
		buttonText?: string;
		linkToCart?: boolean;
	}

	const {
		hide = false,
		isButtonDisabled = false,
		buttonText = "Pokračovat v objednávce",
		linkToCart = false,
	}: Props = $props();

	const { tenant } = getGlobalTemplateProps();
	const cartStore = getCartStore();
	const hasItemsInCart = $derived(Boolean($cartStore.value.productsInOrder.length));
	const price = $derived(getPriceOfOrder($cartStore.value.order));
	const isEmpty = $derived($cartStore.value.order.products.length === 0);
</script>

{#if $cartStore.loaded && !isEmpty}
	<div
		class={[
			"pointer-events-none fixed bottom-0 left-0 right-0 z-40 h-[7.5rem] transition-[bottom,transform] sm:h-[6.5rem]",
			!hasItemsInCart && "-bottom-full",
			hasItemsInCart && "bottom-0",
			hide && "translate-y-full",
		]}
	>
		<div class="bg-panel-shadow h-[2.25rem]"></div>
		<div
			bind:clientHeight={cartSummaryHeight.value}
			class="border-secondary-150 pointer-events-auto flex h-[calc(100%-2.25rem)] flex-col items-center justify-center gap-4 border-t bg-white py-2 sm:flex-row sm:gap-12 lg:gap-16 xl:gap-20"
		>
			<div
				class="container flex flex-col flex-wrap items-center justify-center gap-1 sm:flex-row sm:gap-4 md:gap-6 mb-1 sm:mb-0"
			>
				<div class="flex items-center justify-center gap-4 sm:gap-6 md:gap-10 lg:gap-[2.25rem]">
					<p class="lg:text-md hidden items-center gap-2 text-base font-semibold md:flex">Obsah vašeho košíku</p>
					<div class="flex flex-col items-end">
						<div class="flex items-center gap-4">
							<p class="text-xs lg:text-base">Celkem k úhradě</p>
							<p class="text-md text-right font-bold lg:text-[1.375rem]">
								{formatPrice(price.totalPrice.withTax, tenant.locale, true)}
							</p>
						</div>
						{#if $cartStore.value.properties.cantPayOnlineReasons.includes(CantPayOnlineReason.PriceTooHigh)}
							<p class="text-xs text-nov-red-200">
								Maximální cena objednávky je {formatPrice(maxOnlinePrice, tenant.locale, true)}
							</p>
						{/if}
					</div>
				</div>
				{#if linkToCart}
					<Link href={getCartPath(tenant.locale)} class="!py-[0.5938rem] !text-xs/4" variant={ButtonVariant.Primary}>
						{buttonText}
					</Link>
				{:else}
					<Button
						type="submit"
						disabled={isButtonDisabled}
						class="!py-[0.5938rem] !text-xs/4"
						variant={ButtonVariant.Primary}
					>
						{buttonText}
					</Button>
				{/if}
			</div>
		</div>
	</div>
{/if}
